/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Apps/CustomResource/Content"
  
}) {
let customResourceStatusTypeValueData = fromData.useDataValue({ viewPath,
context: 'custom_resource',
path: 'statusType',
})
let customResourceStatusTextValueData = fromData.useDataFormat({ viewPath,
context: 'custom_resource',
path: 'statusText',
format: fromHelpers.getText,
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 data="custom_resource.statusType"
 type={customResourceStatusTypeValueData}
 style="filled"
 size="tiny"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="custom_resource.statusText"
 format="./helpers.js getText"
 text={customResourceStatusTextValueData}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}